import { Tooltip } from '@repo/design-system/components/ui';
import { Icon } from '@iconify/react';
import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';
import './Button.scss';
import { ButtonSize, ButtonVariant } from './enum/ButtonEnum';

export const Button = forwardRef(function Button({ children, variant = ButtonVariant.PRIMARY,
    size = ButtonSize.MD, loading = false, leftIcon, rightIcon, iconWidth = 16, fullWidth = false,
    className = '', disabled, ttLabel, ttPosition, targetId, type = "button", ...props }, ref) {

    return (
        <React.Fragment>
            <Tooltip label={ttLabel} targetId={targetId} position={ttPosition} />
            <button ref={ref} id={targetId} type={type}
                className={`custom-btn ${variant} ${size} ${fullWidth ? 'full-width' : ''} ${className}`}
                disabled={disabled || loading} {...props}>
                {loading ? (
                    <Icon icon="lucide:loader-2" width={iconWidth} className="btn-icon spin" />
                ) : leftIcon ? (
                    <Icon icon={leftIcon} width={iconWidth} className="btn-icon" />
                ) : null}

                {children && <span className="btn-text">{children}</span>}

                {rightIcon && (
                    <Icon icon={rightIcon} width={iconWidth} className="btn-icon" />
                )}
            </button>
        </React.Fragment>
    );
});

Button.prototype = {
    children: PropTypes.node,
    variant: PropTypes.oneOf(Object.values(ButtonVariant)),
    size: PropTypes.oneOf(Object.values(ButtonSize)),
    loading: PropTypes.bool,
    leftIcon: PropTypes.string,
    rightIcon: PropTypes.string,
    fullWidth: PropTypes.bool,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    ttLabel: PropTypes.string,
    ttPosition: PropTypes.oneOf(['top', 'bottom', 'left', 'right']),
    targetId: PropTypes.string,
    iconWidth: PropTypes.number
};
